import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper';
import {IServiceDetail, IServiceDetailListItem} from "@/entity/services/serviceDetail.types";
import { SiteServicesRequestType } from "@/form/Settings/site/services.types";

@Module({
    namespaced: true,
    name: 'service_detail',
    store,
    dynamic: true
})

class ServiceDetailModule extends VuexModule implements IStoreReady  {
    service_detail: IServiceDetailListItem | null = null
    service_detail_item_loaded = false
    ready = false

    @MutationAction
    async fetchData(data?: PaginationRequestType): Promise<{ service_detail: IServiceDetailListItem;  service_detail_item_loaded: boolean }> {
        let service_detail_item_loaded = false;
        const service_detail = await store.$repository.service_detail.fetchData(data);
        console.log(service_detail);
        if(service_detail){
            service_detail_item_loaded = true;
        }
        return { service_detail, service_detail_item_loaded}
    }

    @Action({rawError: true})
    async create(data: SiteServicesRequestType): Promise<ResponseDataType> {
        return await store.$repository.service_detail.create(data);
    }
    @Action({rawError: true})
    async update(data: any): Promise<ResponseDataType> {
        const formData = new FormData();
        Object.keys(data).forEach((field: string) => {
            if(field == 'procedure_impacts') {
                for(let i = 0; i < data[field].length; i++) {
                    formData.append('procedure_impacts[' + i + ']', data[field][i]);
                }
            } else {
                formData.append(field, data[field])
            }
        });
        return await store.$repository.service_detail.update(formData);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
    
}

export const ServiceDetailStore = getModule(ServiceDetailModule);